export default __webpack_public_path__ + "static/media/iconBadge.52cc89ce.svg";